var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-input-group"},[_c('img',{staticClass:"search-icon",attrs:{"src":require("assets/images/search.svg"),"alt":""}}),_c('input',{staticClass:"search-input",attrs:{"placeholder":_vm.$t("Search name or address"),"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":_vm.debounceInput}})])
}
var staticRenderFns = []

export { render, staticRenderFns }